import ApplicationError, { ErrorSeverity } from 'es/app/business-logic/ApplicationError';
import { NetworkError } from '@apollo/client/errors';
import { ServerParseError, ServerError } from '@apollo/client';

export function isServerError(error: NetworkError): error is ServerError {
    return error?.hasOwnProperty('result') ?? false;
}
export function isServerParseError(error: NetworkError): error is ServerParseError {
    return error?.hasOwnProperty('bodyText') ?? false;
}
export function raiseNetworkError(error: NetworkError) {
    if (isServerError(error)) {
        console.log(error);
        setTimeout(() => {
            if (typeof error.result === 'string') {
                return ApplicationError.raiseError(error.result, null, 'Server Error', ErrorSeverity.Error);
            }
            const details =
                error.result['exceptionMessage'] || error.result['stackTrace']
                    ? `${error.result['exceptionMessage']}\n${error.result['stackTrace']}`
                    : null;
            ApplicationError.raiseError(error.result['message'], details, 'Server Error', ErrorSeverity.Error);
        });
    } else if (isServerParseError(error)) {
        console.log(error);
        setTimeout(() => {
            ApplicationError.raiseError(
                error.message,
                `${error.cause}\n${error.bodyText}`,
                'Server Parser Error',
                ErrorSeverity.Error
            );
        });
    } else {
        setTimeout(() => {
            ApplicationError.raiseError(error, null, 'Network Error', ErrorSeverity.Error);
        });
    }
}
